import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { motion } from "framer-motion";

import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import digiPromo from "@/assets/images/webp/digital-promotion-img.webp";
import digiPromoHightlight1 from "@/assets/images/webp/digital-promotion-key-highlight-1.webp";
import digiPromoHightlight2 from "@/assets/images/webp/digital-promotion-key-highlight-2.webp";
import digiPromoHightlight3 from "@/assets/images/webp/digital-promotion-key-highlight-3.webp";
import EmailCampaigns from "@/assets/images/webp/email-marketing-campaigns.webp";
import SeasonalPromo from "@/assets/images/webp/digital-promotion-seasonal-promotions.webp";


const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <>
      <SeoHelmet
        title={seoConfig.marketingPromotion.title}
        description={seoConfig.marketingPromotion.description}
        keywords={seoConfig.marketingPromotion.keywords}
        author={seoConfig.marketingPromotion.author}
      />
      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      <div>
        <section className="digital-promotion">
          {/* inner banner wrape START  */}
          <div className="inner-banner">
            <div className="container">
              {
                selectedLanguage === "en" ? <div className="content-wrape desk-hide">
                  <h2>
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Digital</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Promotion </motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Services </motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Boost Your Brand Globally</motion.p>
                </div> : <div className="content-wrape desk-hide">
                  <h2>
                    <span className={`light`}>Digital</span>
                    <span className={`blue-text`}> Promotion </span>
                    <span className={`black`}> Services </span>
                  </h2>
                  <p className={``}>Boost Your Brand Globally</p>
                </div>
              }

            </div>
          </div>
          {/* inner banner wrape END  */}

          {/* inner page content START */}
          <div className="inner-page-content-wrape global-trade-network-page">
            <div className='container'>
              {
                selectedLanguage === "en" ? <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Digital</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Promotion </motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Services </motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Boost Your Brand Globally</motion.p>
                </div> : <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <span className={`light`}
                    >Digital</span>
                    <span className={`blue-text`}> Promotion </span>
                    <span className={`black`}> Services </span>
                  </h2>
                  <p className={``}>Boost Your Brand Globally</p>
                </div>
              }


              <div className="subtext-wrape">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.h1 className={`animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Enhance Your Global Brand Presence</motion.h1>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.p className={`medium-size animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade World Inc helps businesses boost their global visibility with targeted digital promotion strategies. We ensure your brand reaches the right audience through impactful messaging, creative designs and data-driven campaigns that support growth across international markets.</motion.p>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                  <div className='img-wrape'>
                    <motion.img src={digiPromo} alt='Digital Promotion' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                </div>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                  <div className='content-wrape'>
                    <div className="head-text">
                      <motion.h2 className="head animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Digital Promotion
                      </motion.h2>
                    </div>

                    <motion.h6 className="varient animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Boost Your Brand Globally</motion.h6>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >At Orex Trade World Inc, we combine creative marketing strategies with industry expertise to help your business stand out in the competitive global marketplace. Our tailored promotional solutions are designed to enhance visibility, build trust and drive meaningful engagement across digital and offline channels.</motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Whether you want to promote your services to verified buyers, attract reliable suppliers or strengthen your global brand image, our team ensures your marketing message reaches the right audience, at the right time  and on the right places. </motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >We offer end-to-end branding solutions, including professional designs, multimedia materials and campaign management to amplify your global reach all at cost-effective rates.</motion.p>
                  </div>
                </div>
              </div>

              {/* verification global network START */}
              <div className="verification-global-wrape" id="social-media-promotion">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="head-text center">
                      <motion.h2 className="head center animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Social Media Promotion
                      </motion.h2>
                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Social media is the heartbeat of modern brand communication and Orex Trade helps you make the most of it. Our targeted social media promotion services ensure your business connects with the right partners on networks like LinkedIn, Facebook, Instagram and X (Twitter).</motion.p>

                      <motion.p
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                        className="animate-child"
                      >We create and manage tailored campaigns that highlight your strengths, showcase your products or services and build credibility within the international trade community. Whether you aim to increase brand awareness, generate leads or position yourself as an industry leader, our strategies deliver measurable engagement and lasting impact.</motion.p>
                    </div>
                  </div>

                  <div className="col-xxl-12">
                    <motion.h5
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Key Highlights</motion.h5>
                    <div className="row custom-scroll-row">
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={digiPromoHightlight1} alt='Targeted global campaigns across key channels' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Targeted global campaigns across key Channels</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={digiPromoHightlight2} alt='Professionally designed creatives and marketing copy' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Professionally designed creatives and marketing copy</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={digiPromoHightlight3} alt='Engagement-focused strategy for brand visibility and leads' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Engagement focused strategy for brand visibility and leads</motion.p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* verification global network END */}
            </div>


            {/* globalPartnerwrape START */}
            <div className="global-partner-wrape" id="email-marketing">
              <div className="img-wrape">
                <motion.img src={EmailCampaigns} alt='Email Marketing Campaigns' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Email Marketing Campaigns
                    </motion.h2>
                  </div>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Reach verified buyers, suppliers and logistics partners directly in their inbox with Orex Trade’s powerful email marketing campaigns. Our team helps craft personalized newsletters, product updates and promotional messages designed to inform, inspire and convert.
                    Each campaign is built using data-driven segmentation and proven engagement tactics to ensure your emails reach the right audience with maximum impact. Whether you want to announce a new service, promote offers or strengthen client relationships, our campaigns help you build trust and increase conversions across global markets.
                  </motion.p>
                  <motion.h5
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Key Highlights</motion.h5>
                  <ul>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Professionally written and designed email templates
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Audience targeting and performance analytics
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Increased engagement and qualified trade leads
                    </motion.li>
                  </ul>
                </div>
              </div>
            </div>
            {/* globalPartnerwrape END */}

            {/* market-inteligence-wrape START */}
            <div className="container market-inteligence-wrape" id="seasonal-promotion">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div className="detail-wrape">
                    <div className="inner-pad">
                      <div className="head-text">
                        <motion.h2 className="head animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          Seasonal Promotions
                        </motion.h2>
                      </div>
                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Take advantage of global trade trends and festive seasons with Orex Trade’s customized seasonal promotions. We help you plan and execute time-sensitive marketing campaigns that capture audience attention when buying interest is at its peak.
                      </motion.p>

                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >From holiday specific offers and festival-based branding to international trade event promotions, we design campaigns that resonate with your audience’s cultural and business cycles. These timely initiatives not only boost visibility but also increase customer engagement, generate repeat business and enhance brand loyalty throughout the year.</motion.p>
                      <div className="clearfix"></div>
                      <motion.h5
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Key Highlights</motion.h5>
                      <ul>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Tailored campaigns for global and regional occasions
                        </motion.li>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Enhanced engagement through strategic timing and messaging
                        </motion.li>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Seasonal visibility that drives sales and strengthens brand recall
                        </motion.li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <motion.img src={SeasonalPromo} alt='Seasonal Promotions' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
            </div>
            {/* market-inteligence-wrape END */}

            {/* gray wrape START */}
            <div className="gray-wrape">
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12">
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Partner with Orex Trade to elevate your brand presence, connect with the right audience and make a lasting impact in the global trade ecosystem. Our Digital Promotion services empower businesses to grow faster, communicate smarter and stand out globally.
                    </motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade – Your Gateway to Global Visibility and Success.</motion.p>
                  </div>
                </div>
              </div>
            </div>
            {/* gray wrape END */}

          </div>
          {/* inner page content END */}
        </section>
      </div>
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  );
};

export default Index;